import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import DrugUnitForm from './DrugUnitForm';

const DrugUnitModal = ({ show, onHide, medhrvalue, drugunitvalue, edittrigger, onCallParent }) => {
    const val = drugunitvalue || medhrvalue;
    const isEdit = Boolean(val && (val.unit_id || val.drug_unit_id || val.hour_id || val.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Drug Unit' : 'Add Drug Unit'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <DrugUnitForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medhrvalue={val}
                    drugunitvalue={val}
                />
            </Modal.Body>
        </Modal>
    );
};

DrugUnitModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medhrvalue: PropTypes.any,
    drugunitvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default DrugUnitModal;
